import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'shared/components';
import { ChartTrendBadge } from 'shared/components/chart/chart-trend-badge';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface MainChartTrendProps {
  countDays: number;
  diffPercents: number;
}
export const MainChartTrend = t0 => {
  const $ = _c(12);
  const {
    countDays,
    diffPercents
  } = t0;
  const {
    tICU
  } = useLocoTranslation();
  const isGrowing = diffPercents >= 0;
  let t1;
  if ($[0] !== countDays || $[1] !== tICU) {
    t1 = tICU("dashboard.main.chart.trend_tooltip", {
      count: countDays
    });
    $[0] = countDays;
    $[1] = tICU;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isGrowing ? "up" : "down";
  const t3 = isGrowing ? "success" : "error";
  let t4;
  if ($[3] !== diffPercents) {
    t4 = Math.abs(diffPercents);
    $[3] = diffPercents;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = <ChartTrendBadge direction={t2} tone={t3}>{t4}%</ChartTrendBadge>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t5) {
    t6 = <Tooltip label={t1}>{t5}</Tooltip>;
    $[9] = t1;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};